import React, { FC } from 'react'
import CheckFilledIcon from 'transfix-icons/build/CheckFilledIcon'
import { Box, Divider, Typography, Skeleton } from 'transfix-ui/core'
import { makeStyles } from 'transfix-ui/core/styles'
import { Button, IconWrapper } from 'transfix-ui'

const useELDIntegrationsListMobileItemStyles = makeStyles({
  header: {
    textTransform: 'uppercase',
  },
  body: {
    paddingTop: 12,
    paddingBottom: 20,
  },
})

interface IELDIntegrationsListMobileItemProps {
  /**
   * Name of the integration
   * @default 'No name'
   * @example 'KeepTruckin'
   */
  name?: string

  /**
   * Is the integration enabled?
   * @default false
   */
  isKeepTruckinEnabled?: boolean

  /**
   * Name of admin that authorized the integration
   * @default ''
   * @example 'Gabe Kramer-Garcia'
   */
  keepTruckinConnector?: string

  /**
   * Callback for when the connect button is clicked
   * @default () => {}
   */
  clickHandler?: () => void
}

export const ELDIntegrationsListMobileItem: FC<IELDIntegrationsListMobileItemProps> = ({
  name = 'No name',
  isKeepTruckinEnabled = false,
  keepTruckinConnector = '',
  clickHandler = () => {},
}) => {
  const classes = useELDIntegrationsListMobileItemStyles()
  return (
    <Box>
      <Box pt={2} className={classes.header}>
        <Typography variant='subtitle1'>{name}</Typography>
      </Box>

      <Box className={classes.body}>
        {isKeepTruckinEnabled ? (
          <Box data-test='eld-integrations-list-item' display='flex'>
            <Box pr={1}>
              <IconWrapper
                color='info'
                Icon={CheckFilledIcon}
                BoxProps={{
                  display: 'flex',
                  alignItems: 'center',
                }}
              />
            </Box>
            <Box>
              <Typography variant='body2' component='div'>
                KeepTruckin Connected
              </Typography>
              {keepTruckinConnector && (
                <Typography variant='body2' component='div' color='textSecondary'>
                  Connected by {keepTruckinConnector}
                </Typography>
              )}
            </Box>
          </Box>
        ) : (
          <Button
            data-test='eld-integrations-connect-button'
            color='primary'
            size='small'
            onClick={clickHandler}>
            Connect ELD
          </Button>
        )}
      </Box>
      <Divider />
    </Box>
  )
}

/**
 * A skeleton component for showing when the data is loading
 */
export const ELDIntegrationsListMobileSkeleton: FC = () => {
  const classes = useELDIntegrationsListMobileItemStyles()
  return (
    <Box>
      <Box pt={2} className={classes.header}>
        <Skeleton variant='rectangular' height='19px' width='124px' />
      </Box>

      <Box className={classes.body}>
        <Skeleton variant='rectangular' height='37px' width='229px' />
      </Box>
      <Divider />
    </Box>
  )
}
